'use strict';
'use es6';

/**
 * pick keys from an object
 *
 * @param {Object} object object to remove keys from
 * @param {Array} toPick keys to pick
 * @returns {Object} new object with the keys removed
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pick = exports.pick = function pick(object) {
  var toPick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return Object.keys(object).reduce(function (acc, key) {
    if (!toPick.includes(key)) return acc;
    acc[key] = object[key];
    return acc;
  }, {});
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/utils/pick.js
// module id = 409
// module chunks = 2 3